import produce from 'immer'
import { assign, filter } from 'lodash'

import {
  DELETE_INGREDIENT_SPECIAL_CASE,
  FETCH_INGREDIENT_SPECIAL_CASES,
} from '../action-types'
import { INGREDIENT_SPECIAL_CASES_INITIAL_STATE } from '../initial-states'

const ingredientSpecialCasesReducer = (
  state = INGREDIENT_SPECIAL_CASES_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_INGREDIENT_SPECIAL_CASES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_INGREDIENT_SPECIAL_CASES.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } =
          action.payload.data.ingredientSpecialCases

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
          latestEvent,
        })
      })

    case FETCH_INGREDIENT_SPECIAL_CASES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: [],
        }),
      )

    case FETCH_INGREDIENT_SPECIAL_CASES.CLEANUP:
      return { ...INGREDIENT_SPECIAL_CASES_INITIAL_STATE }

    case DELETE_INGREDIENT_SPECIAL_CASE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: nextState.data,
          idToDelete: action.payload.id,
          latestEvent: undefined,
        }),
      )

    case DELETE_INGREDIENT_SPECIAL_CASE.COMPLETE:
      return produce(state, nextState => {
        const { id: deletedId, latestEvent } =
          action.payload.data.deleteIngredientSpecialCase

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: filter(nextState.data, ({ id }) => id !== deletedId),
          idToDelete: undefined,
          latestEvent,
        })
      })

    case DELETE_INGREDIENT_SPECIAL_CASE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: nextState.data,
          idToDelete: nextState.idToDelete,
        }),
      )

    default:
      return state
  }
}

export default ingredientSpecialCasesReducer
